"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var validate_exports = {};
__export(validate_exports, {
  validateCancellation: () => validateCancellation,
  validateDefinition: () => validateDefinition,
  validateSubmission: () => validateSubmission
});
module.exports = __toCommonJS(validate_exports);
function validateDefinition(identifier, handler) {
  if (typeof identifier !== "string" || !identifier.trim() || typeof handler !== "function") throw new TypeError("BackgroundTasks.defineTask requires an identifier and handler");
}
function validateSubmission(identifier, earliestBeginDateMs) {
  if (!identifier.trim()) throw new TypeError("BackgroundTasks.submit requires an identifier");
  if (earliestBeginDateMs !== void 0 && (!Number.isFinite(earliestBeginDateMs) || earliestBeginDateMs < 0)) throw new RangeError("BackgroundTasks.submit earliestBeginDateMs must be a timestamp");
}
function validateCancellation(identifier) {
  if (!identifier.trim()) throw new TypeError("BackgroundTasks.cancel requires an identifier");
}
//# sourceMappingURL=validate.js.map
